module.exports = __webpack_public_path__ + "img/elvis-fanday-88.03f8e79e.jpg";